import React from 'react'

import { ImpactIcon } from 'src/components/SpriteIcon'
import CountUpWrapper from 'src/components/CountUpWrapper'
import Progress       from './Progress'

import formatNumber from 'src/utils/formatNumber'
import moneyFormat  from 'src/utils/moneyFormat'

const Impact = ({ icon, money_format, currency_symbol, amount, goal, description, impact_type }) => {
  const showGoal = (() => {
    switch (impact_type) {
      case 'dollar': return true
      case 'either': return !!currency_symbol
      default: return false
    }
  })()

  return (
    <div className="p-2 overlay rounded-3">
      <h2 className="h4 mb-0">
        <ImpactIcon icon={icon} className="me-1" />
        <CountUpWrapper
          {...moneyFormat(money_format, currency_symbol)}
          amount={amount}
        />
        {' '}
        <small className="text-slightly-muted">
          { showGoal
            ? goal > 0
            ? `of $${formatNumber(goal).split('.')[0]} goal`
            : 'in donations'
            : description
          }
        </small>
      </h2>
      { showGoal && goal > 0 ?
        <Progress raised={amount} goal={goal} />
        : null
      }
    </div>
  )
}

export default Impact
